import React from 'react'
import { styled } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import {
  Typography,
  DialogActions,
  DialogContent,
  Dialog,
  Button,
  Box,
  Stack,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from '@mui/material'
import HeartGif from '../../images/heart.gif'
import { useState } from 'react'
import { useEffect } from 'react'

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    paddingLeft: theme.spacing(15),
    paddingRight: theme.spacing(15),
    paddingTop: theme.spacing(5),
    // paddingBottom: theme.spacing(10),
  },
  '& .MuiDialogActions-root': {
    paddingLeft: theme.spacing(15),
    paddingRight: theme.spacing(15),
    paddingBottom: theme.spacing(5),
  },
}))

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    '& .MuiTableCell-root': {
      borderLeft: '1px solid rgba(224, 224, 224, 1)',
    },
  },
})

const NinetyDayPopup = ({ openNinty, handleNintyClickClose, handleSubmit }) => {
  const [requestType, setRequestType] = useState(null)
  const classes = useStyles()
  useEffect(() => {
    setRequestType(null)
  }, [openNinty])

  return (
    <div>
      <BootstrapDialog
        onClose={handleNintyClickClose}
        aria-labelledby="customized-dialog-title"
        open={openNinty}
        fullWidth={true}
        maxWidth={'md'}
        scroll="paper"
      >
        <DialogContent>
          <Box>
            <Stack sx={{ alignItems: 'center' }}>
              <img src={HeartGif} alt="heart" width="96px" />
              <Typography variant="h4" sx={{ my: 3 }}>
                Welcome back!
              </Typography>
              <Typography>Important Note: Only the owner can request changes to the policy</Typography>

              <FormGroup sx={{ mt: 5 }} component="fieldset" variant="standard">
                <Typography variant="subtitle2">Please confirm the change(s) your client wishes to make:</Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={requestType === 1}
                      onChange={(e) => setRequestType((prev) => (prev === 1 ? null : 1))}
                    />
                  }
                  label="Change to Term Rider"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={requestType === 2}
                      onChange={(e) => setRequestType((prev) => (prev === 2 ? null : 2))}
                    />
                  }
                  label="Change to Face Amount"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={requestType === 3}
                      onChange={(e) => setRequestType((prev) => (prev === 3 ? null : 3))}
                    />
                  }
                  label="Change to the annual PUAR limit"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={requestType === 4}
                      onChange={(e) => setRequestType((prev) => (prev === 4 ? null : 4))}
                    />
                  }
                  label="Add or remove a rider"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={requestType === 5}
                      onChange={(e) => setRequestType((prev) => (prev === 5 ? null : 5))}
                    />
                  }
                  label="PII change"
                />
              </FormGroup>
            </Stack>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: 'center',
          }}
        >
          <Button
            variant="outlined"
            sx={{
              borderRadius: '100px',
              px: 2,
              '&:hover': {
                backgroundColor: '#3C4FB9',
                color: 'white',
              },
              '&:active': {
                backgroundColor: '#3C4FB9',
                color: 'white',
              },
            }}
            onClick={() => handleSubmit(requestType)}
            disabled={!requestType}
          >
            <Typography variant="body2">Continue Application</Typography>
          </Button>
          <Button
            variant="outlined"
            sx={{
              borderRadius: '100px',
              px: 2,
              '&:hover': {
                backgroundColor: '#3C4FB9',
                color: 'white',
              },
              '&:active': {
                backgroundColor: '#3C4FB9',
                color: 'white',
              },
            }}
            onClick={handleNintyClickClose}
          >
            <Typography variant="body2">Close</Typography>
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  )
}

export default NinetyDayPopup
